import Ellipse from "./shapes/Ellipse";
import AbstractProvidedClass from "../shared/AbstractProvidedClass";
import Appearance from "./Appearance";
import Line from "./shapes/Line";
import Polygon from "./shapes/Polygon";
import Rectangle from "./shapes/Rectangle";
import Label from "./Label";

export default class ShapeFactory extends AbstractProvidedClass {
    make(data) {
        let shape = null;
        switch (data.type) {
            case 'rectangle':
                shape = this.makeRectangle(data);
                break;
            case 'ellipse':
                shape = this.makeEllipse(data);
                break;
            case 'line':
                shape = this.makeLine(data);
                break;
            case 'polygon':
                shape = this.makePolygon(data);
                break;
            default:
                throw new Error(`Unknown shape type: ${data.type}`);
        }
        return shape;
    }

    makeRectangle(data) {
        let r = new Rectangle(this.provider, data.data, this.makeAppearance(data.data), data.speciesIds, this.makeLabel(data.data));
        return r;
    }

    makeEllipse(data) {
        return new Ellipse(this.provider, data.data, this.makeAppearance(data.data), data.speciesIds, this.makeLabel(data.data));
    }

    makeLine(data) {
        return new Line(this.provider, data.data, this.makeAppearance(data.data), data.speciesIds, this.makeLabel(data.data));
    }

    makePolygon(data) {
        return new Polygon(this.provider, data.data, this.makeAppearance(data.data), data.speciesIds, this.makeLabel(data.data));
    }

    makeAppearance(data) {
        return new Appearance(
            this.provider,
            {
                fillColor: data.fillColor ? this.p.color(data.fillColor) : null,
                strokeColor: data.strokeColor ? this.p.color(data.strokeColor) : null,
                strokeWidth: data.strokeWidth
            }
        );
    }

    makeLabel(data) {
        return new Label(
            this.provider,
            {
                labels: data.labels,
                labelX: data.labelX,
                labelY: data.labelY,
            }
        );
    }
}
